
import { Component, Vue } from 'vue-property-decorator'
import { PersonService } from '@/services'
import PersonTable from './components/person_settle_table.vue'
import FullLoading from '@/components/full_loading/index.vue'

@Component({
    name: 'person-settle',
    components: {
        PersonTable,
        FullLoading
    }
})
export default class extends Vue {
    private personList = []
    private pageIndex = 1
    private pageSize = 50
    private pageTotal = 0
    private isLoading = false
    private loadingText = ''
    private status = -1
    private statusOptions = [
        { label: '所有申请', value: -1 },
        { label: '审核中', value: 1 },
        { label: '通过', value: 2 },
        { label: '不通过', value: 3 }
    ]


    private async mounted() {
        this.showLoading()
        await this.getPersonList()
        this.hideLoading()
    }

    /** 获取企业列表 */ 
    private async getPersonList() {
        const status = this.status === -1 ? undefined : this.status
        const params = {
            status: status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await PersonService.getPersonSettleList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.personList = result.data.list
        }
    }   

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getPersonList()
    }

    private showLoading() {
        this.isLoading = true
    }

    private hideLoading() {
        this.isLoading = false
    }
}
